import WalletMenu from "./WalletMenu";

export default WalletMenu;